import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { DEFAULT_ROUTE } from "./components/navigation/Navigation";
// Config
import Devices from "./pages/devices";
import IoTKeyDevices from "./pages/IoTKeyDevice";
import Templates from "./pages/templates/Templates";
import Device from "./pages/devices/Device/Device";
import NewDevice from "./pages/devices/NewDevice/NewDevice";
import TemplateView from "./pages/templates/TemplateView";
import TransformationView from "./pages/templates/TransformationView";
import VehicleTemplateCreating from "./pages/vehicleTemplates/VehicleTemplateCreating/VehicleTemplateCreating";
import VehicleTemplateEditing from "./pages/vehicleTemplates/VehicleTemplateEditing/VehicleTemplateEditing";
import ReportConfigsPage from "./pages/reportConfigs/ReportConfigsPage";
import NewReportConfig from "./pages/reportConfigs/components/NewReportConfig";
import EditReportConfig from "./pages/reportConfigs/components/EditReportConfig";
// Admin
import Fleet from "./pages/fleet";
import VehicleGroupView from "./pages/fleet/VehicleGroupView";
import VehicleIncidentView from "./pages/fleet/incidents/VehicleIncidentView";
import VehicleIncidentCreate from "./pages/fleet/incidents/VehicleIncidentCreate";
import NewVehicleTemplate from "./pages/fleet/NewVehicleTemplate";
import VehicleTemplateView from "./pages/fleet/VehicleTemplateView";
import Drivers from "./pages/drivers";
import NewDriver from "./pages/drivers/NewDriver";
import OrgSettings from "./pages/orgSettings/OrgSettings";
import InternalBilling from "./pages/InternalBilling/InternalBilling";
// Settings
import Settings from "./pages/settings";
import Login from "./pages/auth/Login";
import VehicleTemplatesContainer from "./pages/vehicleTemplates/VehicleTemplatesContainer";
import VehicleMappingCreate from "./pages/vehicleTemplates/ValuesMappings/ValuesMappingCreate";
import VehicleMappingEdit from "./pages/vehicleTemplates/ValuesMappings/ValuesMappingEdit";
import SMSCommands from "./pages/smsCommands/SMSCommands";
import CreateSMSCommand from "./pages/smsCommands/CreateSMSCommand";
import NewIoTKeyDevice from "./pages/IoTKeyDevice/NewIoTkeyDevice";
import IoTKeyDeviceView from "./pages/IoTKeyDevice/IoTKeyDeviceView";
import CreateDeviceConfigPage from "./pages/config/create-config-page/CreateDeviceConfigPage";
import EditDeviceConfigPage from "./pages/config/edit-config-page/EditDeviceConfigPage";
import EditFirmwarePage from "./pages/firmware/edit-firmware-page/EditFirmwarePage";
import CreateFirmwarePage from "./pages/firmware/create-firmware-page/CreateFirmwarePage";
import IoTKeyCommands from "./pages/IoTKeyCommands/IoTKeyCommands";
import CreateEditIoTKeyCommandPage from "./pages/IoTKeyCommands/CreateEditIoTKeyCommandPage/CreateEditIoTKeyCommandPage";
import VehicleView from "./pages/backendVehicles/VehicleView";

export const publicRoutes = (
  <Switch>
    <Route path="/login" exact>
      <Login />
    </Route>
    <Redirect to="/login" />
  </Switch>
);

export const privateRoutes = (
  <Switch>
    <Route path="/admin/fleet/groups/:groupId/:tabId" exact>
      <VehicleGroupView />
    </Route>
    <Route path="/admin/fleet/templates/create" exact>
      <NewVehicleTemplate />
    </Route>
    <Route path="/admin/fleet/templates/:vehicleTemplateId" exact>
      <VehicleTemplateView />
    </Route>
    <Route path="/admin/fleet/incidents/create" exact>
      <VehicleIncidentCreate />
    </Route>
    <Route path="/admin/fleet/incidents/:incidentId" exact>
      <VehicleIncidentView />
    </Route>
    <Route path="/admin/fleet">
      <Fleet />
    </Route>

    {/* Drivers */}
    <Route path="/admin/drivers/create" exact>
      <NewDriver />
    </Route>
    <Route path="/admin/drivers/:driverId" exact>
      <NewDriver />
    </Route>
    <Route path="/admin/drivers" exact>
      <Drivers />
    </Route>

    {/* Org Settings */}
    <Route path="/admin/settings">
      <OrgSettings />
    </Route>
    {/* Billing */}
    <Route path="/admin/billing">
      <InternalBilling />
    </Route>
    {/* Backend Vehicles */}
    <Route path="/config/vehicles/:uuid" exact>
      <VehicleView />
    </Route>
    {/* Devices */}
    <Route path="/config/devices/create" exact>
      <NewDevice />
    </Route>
    <Route path="/config/devices/device/:imei">
      <Device />
    </Route>
    <Route path="/config/devices/config/create">
      <CreateDeviceConfigPage />
    </Route>
    <Route path="/config/devices/config/:id">
      <EditDeviceConfigPage />
    </Route>
    <Route path="/config/devices/firmware/create">
      <CreateFirmwarePage />
    </Route>
    <Route path="/config/devices/firmware/:id">
      <EditFirmwarePage />
    </Route>
    {/* IoT Key Devices */}
    <Route path="/config/iot_key_devices/create" exact>
      <NewIoTKeyDevice />
    </Route>
    <Route path="/config/iot_key_devices/device/:id" exact>
      <IoTKeyDeviceView />
    </Route>
    {/* Templates */}
    <Route path="/config/templates/templates/:name" exact>
      <TemplateView />
    </Route>
    <Route path="/config/templates/transformations/create" exact>
      <TransformationView edit={false} />
    </Route>
    <Route path="/config/templates/transformations/:name" exact>
      <TransformationView edit />
    </Route>
    <Route path="/config/templates/*" exact>
      <Templates />
    </Route>

    {/* Vehicle templates */}
    <Route path="/config/vehicle/templates/templates/create">
      <VehicleTemplateCreating />
    </Route>
    <Route path="/config/vehicle/templates/templates/:vehicleTemplateId">
      <VehicleTemplateEditing />
    </Route>
    <Route path="/config/vehicle/templates/value_mappings/create">
      <VehicleMappingCreate />
    </Route>
    <Route path="/config/vehicle/templates/value_mappings/:mappingId">
      <VehicleMappingEdit />
    </Route>
    <Route path="/config/vehicle/templates">
      <VehicleTemplatesContainer />
    </Route>

    {/* Reports configuration */}
    <Route exact path="/config/report_configs">
      <ReportConfigsPage />
    </Route>
    <Route path="/config/report_configs/create">
      <NewReportConfig />
    </Route>
    <Route path="/config/report_configs/edit">
      <EditReportConfig />
    </Route>

    {/* SMS */}
    <Route exact path="/config/sms">
      <SMSCommands />
    </Route>
    <Route path="/config/sms/create">
      <CreateSMSCommand />
    </Route>
    <Route path="/config/sms/:mappingId">
      <CreateSMSCommand edit />
    </Route>

    {/* IoT Key Commands */}
    <Route exact path="/config/iot_commands">
      <IoTKeyCommands />
    </Route>
    <Route path="/config/iot_commands/create">
      <CreateEditIoTKeyCommandPage />
    </Route>
    <Route path="/config/iot_commands/:mappingId">
      <CreateEditIoTKeyCommandPage edit />
    </Route>

    {/* Config */}
    <Route path="/config/devices">
      <Devices />
    </Route>
    <Route path="/config/iot_key_devices">
      <IoTKeyDevices />
    </Route>
    <Route path="/settings">
      <Settings />
    </Route>
    <Redirect to={DEFAULT_ROUTE} />
  </Switch>
);
